<template>
    <div>
        <search-panorama-excluded-subjects v-model="excludedSubjects" :subjects="subjects" />
    </div>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import SearchPanoramaExcludedSubjects from "./SearchPanoramaExcludedSubjects.vue";

export default {
    props: ["value", "subjects"],
    components: {
        SearchPanoramaExcludedSubjects,
    },
    data() {
        return {
            excludedSubjects: this.value.excludedSubjects,
        };
    },
    methods: {
        updateFilters() {
            this.$emit("input", {
                excludedSubjects: this.excludedSubjects,
            });
        },
    },
    mounted() {
        EventBus.$on("clearPanoramaFilters", () => {
            this.excludedSubjects = null;
        });
    },
    watch: {
        excludedSubjects: {
            handler() {
                this.updateFilters();
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="sass"></style>
